export default "__VITE_ASSET__CAyOEwFe__"